export const ROOT_URL = `${process.env.API_BASE_URL}`;
export const ASSETS_PATH = `${process.env.ASSETS_PATH}`;
export const ETHER_SCAN_URL = `${process.env.ETHER_SCAN_URL}`;
export const VESTING_1_ADDRESS = `${process.env.VESTING_1_ADDRESS}`;
export const VESTING_2_ADDRESS = `${process.env.VESTING_2_ADDRESS}`;
export const VESTING_3_ADDRESS = `${process.env.VESTING_3_ADDRESS}`;
export const API_KEY_ONRAMPER = `${process.env.API_KEY_ONRAMPER}`;
export const UNIT_ONRAMPER = `${process.env.UNIT_ONRAMPER}`;
export const VESTING_1_END_DATE = `${process.env.VESTING_1_END_DATE}`;
export const VESTING_2_END_DATE = `${process.env.VESTING_2_END_DATE}`;
